import dayjs, { extend, type ManipulateType, type QUnitType } from 'dayjs';
import utc from 'dayjs/plugin/utc';

extend(utc);

export function handleInputDate(date?: string) {
    if (date?.endsWith('Z')) return dayjs(date).utc().toISOString().substring(0, 16);

    return date;
}

export function formattedDate(date?: string, format = 'YYYY-MM-DDTHH:mm') {
    return dayjs.utc(date).format(format);
}

export function getDiff(date1?: string, date2?: string, unit: QUnitType = 'm') {
    return dayjs(date2).diff(dayjs(date1), unit);
}

export function formattedPostDate(date) {
    if (date) {
        if (date.endsWith('Z')) return date;
        return date ? `${date}:00Z` : undefined;
    }
}

export function addTime(date: string, amount: number, unit: ManipulateType = 'days') {
    return dayjs.utc(date).add(amount, unit).format('YYYY-MM-DDTHH:mm');
}
